import React from 'react';
import PropTypes from 'prop-types';
import Groups from './Groups';
import './SideNav.css';

const SideNav = ({ commandGroups, eventGroups }) => (
    <div className="side-nav">
        <Groups groups={commandGroups} title="Commands" path="/commands" />
        <Groups groups={eventGroups} title="Events" path="/events" />
    </div>
);

SideNav.propTypes = {
    commandGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
    eventGroups: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default SideNav;
